import { render, staticRenderFns } from "./rappel.vue?vue&type=template&id=2124a5b9"
import script from "./rappel.vue?vue&type=script&lang=js"
export * from "./rappel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports